<div class="print-info">
  <div class="print-logo-wrapper">
    <img src="assets/logo_full.png" width="206" height="59" alt="Printable Krupion Puzzle" class="print-logo" />
  </div>
  <div class="print-text-wrapper">
    <h2>{{ "PUZZLE.print_info.eyebrow" | translateWithDate }}</h2>
    <h1>{{ "PUZZLE.print_info.title" | translate }}</h1>
  </div>
</div>
